import { Grid, Stack, Typography } from "@mui/material";
import { GetApp } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";

import { useForm } from "react-hook-form";
import nameof from "ts-nameof.macro";
import download from "js-file-download";
import { format } from "date-fns";

import AlertExtended from "../../../../common/components/mui-extended/AlertExtended";
import DatePickerExtended from "../../../../common/components/mui-extended/DatePickerExtended";
import SectionExtended from "../../../../common/components/mui-extended/SectionExtended";
import { ReportLogProps, ReportLogSearchDto, ReportLogType } from "../../../../interfaces/admin/LogReport";
import { useAxiosLoader } from "../../../../common/hooks/useAxiosLoader";
import { Rules } from "../../../../common/validationRules";
import reportLogService from "../../../../services/reportLogService";
import { useState } from "react";

export default function Search({ reportLogType, registerName }: ReportLogProps) {
  const loading = useAxiosLoader(false);
  const [hasResults, setHasResults] = useState(true);

  const defaultModel: ReportLogSearchDto = {
    reportLogType: reportLogType,
  };

  const form = useForm<ReportLogSearchDto>({
    mode: "all",
    defaultValues: defaultModel,
  });

  const onSubmit = (model: ReportLogSearchDto) => {
    reportLogService.getReportLogs(model).then((response) => {
      if (response.data.size !== 0) {
        setHasResults(true);
        download(response.data, getZipFileName(reportLogType));
      } else {
        setHasResults(false);
      }
    });
  };

  const getZipFileName = (reportLogType: ReportLogType): string => {
    const suffix = `report_${format(new Date(), "yyyyMMddHHmm")}.zip`;

    switch (reportLogType) {
      case ReportLogType.BankAuthorizationReportLog:
        return `bank_${suffix}`;
      case ReportLogType.BankWithdrawnAuthorizationReportLog:
        return `bank_${suffix}`;
      case ReportLogType.InvestmentBrokerAuthorizationLog:
        return `investment_broker_${suffix}`;
      case ReportLogType.InvestmentBrokerWithdrawnAuthorizationLog:
        return `investment_broker_${suffix}`;
      case ReportLogType.InsurerAuthorizationLog:
        return `insurer_${suffix}`;
      case ReportLogType.InsurerWithdrawnAuthorizationLog:
        return `insurer_${suffix}`;

      default:
        return `bwrong_file_name_${suffix}`;
    }
  };

  return (
    <Stack spacing={3}>
      <Typography variant="h5">{registerName}</Typography>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <SectionExtended title="Период на справката">
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <DatePickerExtended
                label="От дата"
                name={nameof(defaultModel.fromDate)}
                form={form}
                rules={Rules.Required}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DatePickerExtended
                label="До дата"
                name={nameof(defaultModel.toDate)}
                form={form}
                rules={Rules.Required}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <LoadingButton
                variant="contained"
                loading={loading}
                loadingPosition="start"
                type="submit"
                startIcon={<GetApp />}
              >
                Експорт
              </LoadingButton>
            </Grid>
          </Grid>
        </SectionExtended>
      </form>
      {!hasResults && <AlertExtended type="warning">Няма намерени резултати.</AlertExtended>}
    </Stack>
  );
}
